<template>
    <div>
        <Modal v-model="isShow" footer-hide="true" @on-visible-change="onVisibleChange" :style="{textAlign:'center'}" width="768" >
            <Row>
                <Col span="8">
                    <div>
                        <img :src="loginImgUrl.king" style="width: 100px;height: 100px"/>
                        <p style="text-align: center;font-weight: bold">{{lang('payAlertTitle',language)}}</p>
                        <Divider/>
                        <p style="text-align: left;font-weight: bold">{{lang('payAlertOpenTitle',language)}}</p>
                        <ul style="margin-left: 18px">
                            <li v-for="item in [0,1,2]" :key="item" style="text-align: left">
                                {{lang('payAlertOpenPermission'+item,language)}}
                            </li>
                        </ul>
                        <br>
                        <br>
                        <p style="text-align: left;font-weight: bold">{{lang('payAlertAppTitle',language)}}</p>
                        <ul style="margin-left: 18px">
                            <li v-for="item in [0,1,2,3,4,5]" :key="item" style="text-align: left">
                                {{lang('payAlertAppPermission'+item,language)}}
                            </li>
                        </ul>
                        <br>
                        <p style="text-align: left;color:#A9A9A9">{{lang('payAlertText1',language)}}</p>
                    </div>
                </Col>
                <Col span="16">
                    <div style="margin-top: 100px">
                        <vue-qr :logoSrc="loginImgUrl.wawayaya" :text='qrCodeText' :size="250"
                                :style="" :logoMargin="5"></vue-qr>
                        <br>
                        <br>
                        <p style="font-size: 20px;font-weight: bold">{{lang('payAlertText3',language)}}</p>
                    </div>
                </Col>
            </Row>
        </Modal>
    </div>
</template>

<script>
    import vueQr from 'vue-qr';
    import config from '@/utils/config.js';
    import {lang} from "@/utils/language.js";
    import store from '@/store/index.js';
    export default {
        name: "PayAlert",
        store,
        components:{
            vueQr,
        },
        props:['isShow'],
        data(){
            return {
                lang: lang,
                loginImgUrl: {
                    wawayaya: require('../assets/48.png'),
                    king: require('../assets/king.png')
                },
                qrCodeText:config.weexPayPath,
            }
        },
        methods:{
            onVisibleChange(data){
                this.isShow = data;
                this.$emit('increase', this.isShow);
            }
        },
        computed: {
            language: function () {
                this.stateLang = store.state.lang;
                return store.state.lang;
            },
        },
        watch: {
            stateLang: function () {

            }
        },
    }
</script>

<style scoped>

</style>